export const colors = {
  primary: '#46BB89',
  background: '#F5F7F4',
  sectionBackground: '#232323',
  border: '#939597',
  accent: '#46BB89',
  success: '#46BB89',
  muted: '#939597',
  text: '#46BB89',
  overlay: 'rgba(35,35,35,0.8)',
  statusYellow: '#FFC107',
  danger: '#EC2124',
  unknown: '#000000',
  page: '#0B0F0D',
  pageAlt: '#111614',
  surface: '#151B19',
  surfaceRaised: '#1D2522',
  surfaceMuted: '#101412',
  panelBorder: 'rgba(147,149,151,0.28)',
  panelBorderStrong: 'rgba(147,149,151,0.46)',
  textStrong: '#F5F7F4',
  textBody: '#E1E6E2',
  textMuted: '#A0AAA4',
  textDim: '#76817C',
  shadow: '0 24px 60px rgba(0,0,0,0.28)'
};
